import React from 'react';
import classNames from 'classnames';

import {FIELD_NAME_TO_DISPLAY} from 'shared/utils';
import {TestScore} from './test-scores-form-wrapper';

interface Props {
  _id: TestScore['_id'];
  type: TestScore['type'];
  scores: TestScore['scores'];
  hover?: boolean;
}

const ScoreNodes = ({_id, hover, scores, type}: Props) =>
  Object.keys(scores).map((scoreName) => (
    <div
      key={`${_id}-${scoreName}`}
      className={classNames('test-score-node', {'other-test': type === 'other'})}
    >
      <div className={classNames('test-score-node-circle', {hover})}>{scores[scoreName]}</div>
      <div className={classNames('test-score-node-field', {hover})}>
        {FIELD_NAME_TO_DISPLAY[scoreName] || ''}
      </div>
    </div>
  ));

export default ScoreNodes;
